var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Field } from 'formik';
import { Autocomplete } from 'formik-material-ui-lab';
import React from 'react';
import { LabeledInput, Wrapper } from './CustomAutoCompleteField.Styles';
export var CustomAutoCompleteField = function (props) {
    var proptions = props.options || [];
    return (React.createElement(Wrapper, { half: props.half },
        React.createElement(Field, __assign({ onChange: function (event, data) {
                props.form.setFieldValue(props.field.name, data);
                props.onHandleChange && props.onHandleChange(data);
            } }, props, { name: props.name, component: Autocomplete, options: proptions.map(function (o) { return o.value; }), getOptionLabel: function (option) {
                var _a;
                return ((_a = proptions.find(function (o) { return o.value === option; })) === null || _a === void 0 ? void 0 : _a.label) ||
                    option;
            }, getOptionSelected: function (option) {
                return true;
            }, getOptionDisabled: function (option) { var _a; return !!((_a = props.disabledValues) === null || _a === void 0 ? void 0 : _a.find(function (value) { return value === option; })); }, onBlur: function (e) {
                var value = proptions.find(function (op) { return op.label === e.target.value; });
                if (value === undefined) {
                    props.form.setFieldValue(props.field.name, '');
                }
            }, filterOptions: function (options) {
                var _a, _b, _c;
                if (!((_a = props.field.value) === null || _a === void 0 ? void 0 : _a.length))
                    return options;
                var validOptions = [];
                for (var _i = 0, proptions_1 = proptions; _i < proptions_1.length; _i++) {
                    var _d = proptions_1[_i], label = _d.label, value = _d.value;
                    if (value === ((_b = props.field) === null || _b === void 0 ? void 0 : _b.value)) {
                        return options;
                    }
                    if (label
                        .toLocaleLowerCase()
                        .includes((_c = props.field.value) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) ||
                        props.field.value === '' ||
                        !props.field.value) {
                        validOptions.push(value);
                    }
                }
                return validOptions;
            }, renderInput: function (params) { return (React.createElement(LabeledInput, __assign({ placeholder: props.placeholder, field: props.field, form: props.form, meta: props.meta }, params, { label: props.label, variant: 'outlined', margin: 'dense', InputLabelProps: __assign(__assign({}, params.InputLabelProps), { shrink: true }), InputProps: __assign(__assign({}, params.InputProps), { notched: false }) }))); } }))));
};
CustomAutoCompleteField.defaultProps = {};
//# sourceMappingURL=CustomAutoCompleteField.js.map